// extracted by mini-css-extract-plugin
export default {"logoTextBanner":"trZNw-ojs4M1q4J5+SCabQ==","logo":"_6W-i5-Uy9zxVsalY3M90CA==","content":"KRJqeMvRGjU7BOpoVlJjSw=="};